module.exports = __webpack_public_path__ + "img/vidogar-sa.9c86b316.jpg";